export enum PageType {
	StaticPage = 'StaticPage',
	NotFoundPage = 'NotFoundPage',
	ParametersPage = 'ParametersPage',
	ProfilePage = 'ProfilePage',
	ProposalStatsPage = 'ProposalStatsPage',
	NotesPage = 'NotesPage',
	DrivePage = 'DrivePage',
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Page/constants.ts